import { defineStore } from "pinia";
import type { IUidPinLoginResponse } from "~/types/login";
import type { IProfileDataresponse } from "~/types/profile";
import type { ProfileModel } from "~/utils/validation/profileSchema";
import type { IStateCity } from "~/types/common";
import { COMMON_CONSTANTS } from "~/constants/common-constants";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    user: null as IUidPinLoginResponse["data"] | null,
    pageId: null as string | null,
    profile: null as IProfileDataresponse | null,
  }),
  actions: {
    setUser(data: IUidPinLoginResponse["data"]) {
      this.user = data;
    },
    setProfile(data: IProfileDataresponse) {
      this.profile = data;
    },
    clearUser() {
      this.user = null;
      this.pageId = null;
    },
    setPageId(id: string) {
      this.pageId = id;
    },
    setProfileState(data: IStateCity) {
      if (this.profile) {
        this.profile.data.state_name = data.name;
        this.profile.data.state_id = data.id;
      }
    },
    setProfileCity(data: IStateCity) {
      if (this.profile) {
        this.profile.data.city_name = data.name;
        this.profile.data.city_id = data.id;
      }
    },
    clearUserStore() {
      this.user = null;
      this.profile = null;
      this.pageId = null;
    },
  },
  getters: {
    getPageId: (state) => state.pageId,
    getUserReferralCode: (state) => state.user?.referral_code ?? "",
    getHasOrganizationBudget: (state) =>
      state.profile?.data.has_organization_budget ===
      COMMON_CONSTANTS.POSITIVE_VALUE,
    getProfileFormValues(state): ProfileModel {
      return {
        first_name: state.profile?.data.first_name ?? "",
        last_name: state.profile?.data.last_name ?? "",
        mobile_number: state.profile?.data.mobile_number ?? "",
        email: state.profile?.data.email ?? "",
        uid: state.profile?.data.uid ?? "",
        dob: state.profile?.data.dob ?? "",
        anniversary_date: state.profile?.data.anniversary_date ?? "",
        address: state.profile?.data.address ?? "",
        city_name: state.profile?.data.city_name ?? "",
        city_id: state.profile?.data.city_id ?? "",
        state_name: state.profile?.data.state_name ?? "",
        state_id: state.profile?.data.state_id ?? "",
        pincode: state.profile?.data.pincode ?? "",
      };
    },
  },
});
